import {
    SIGNUP_COMMAND_URL,
    SIGNUP_PULSE_URL,
    SIGNUP_SOVEREIGN_URL,
    SIGNUP_TRIAL_URL,
} from "@/constants/links";

function Check() {
    return (
        <span className="plan__feature-check" aria-hidden="true">
            <svg
                width="10"
                height="10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="4 12 10 18 20 6" />
            </svg>
        </span>
    );
}

function ArrowCarry() {
    return (
        <span className="plan__feature-check" aria-hidden="true">
            <svg
                width="10"
                height="10"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <polyline points="5 12 19 12" />
                <polyline points="13 6 19 12 13 18" />
            </svg>
        </span>
    );
}

function ShieldIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 2 4 5v7c0 4.5 3.4 8.7 8 10 4.6-1.3 8-5.5 8-10V5l-8-3Z" />
        </svg>
    );
}
function ReceiptIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z" />
            <line x1="9" y1="8" x2="15" y2="8" />
            <line x1="9" y1="12" x2="15" y2="12" />
        </svg>
    );
}
function BoltIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <polyline points="13 2 4 14 12 14 11 22 20 10 12 10 13 2" />
        </svg>
    );
}
function XIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="9" />
            <line x1="9" y1="9" x2="15" y2="15" />
            <line x1="15" y1="9" x2="9" y2="15" />
        </svg>
    );
}

export default function Pricing() {
    return (
        <section className="pricing" id="pricing" data-testid="v2-pricing">
            <div className="container">
                <div className="pricing__head reveal">
                    <span className="pricing__eyebrow">Pricing</span>
                    <h2
                        className="pricing__title"
                        data-testid="v2-pricing-title"
                    >
                        Choose the plan that fits your business.
                    </h2>
                    <p className="pricing__sub">
                        Start with the management capabilities your business
                        needs today. <strong>Scale your C-ORE access</strong> as
                        your business grows.
                    </p>
                </div>

                <div className="pricing__grid">
                    {/* Trial */}
                    <article
                        className="plan plan--trial reveal"
                        data-testid="v2-plan-trial"
                    >
                        <span className="plan__eyebrow">
                            <span
                                className="plan__eyebrow-dot"
                                aria-hidden="true"
                            />
                            C-ORE Trial
                        </span>
                        <h3 className="plan__name">Trial</h3>
                        <p className="plan__tag">
                            Full C-ORE, 15 days &mdash; understand the layer
                            first.
                        </p>

                        <div className="plan__price">
                            <span className="plan__price-free">Free</span>
                        </div>
                        <p className="plan__price-hint">
                            15-day full access &middot; No credit card
                        </p>

                        <span className="plan__divider" aria-hidden="true" />

                        <ul className="plan__features">
                            <li className="plan__feature">
                                <Check /> 15-day full access
                            </li>
                            <li className="plan__feature">
                                <Check /> C-ORE CEO, CFO, CMO &amp; CTO
                            </li>
                            <li className="plan__feature">
                                <Check /> Boardroom &amp; Executive Briefing
                            </li>
                            <li className="plan__feature">
                                <Check /> Financial Intelligence
                            </li>
                            <li className="plan__feature">
                                <Check /> C-ORE One CRM Suite included
                            </li>
                            <li className="plan__feature">
                                <Check /> Company Trajectory &amp; Forecasting
                            </li>
                            <li className="plan__feature">
                                <Check /> Ask C-ORE
                            </li>
                            <li className="plan__feature">
                                <Check /> No credit card required
                            </li>
                        </ul>

                        <a
                            className="plan__cta plan__cta--outline"
                            href={SIGNUP_TRIAL_URL}
                            data-testid="v2-plan-trial-cta"
                        >
                            Start free trial
                        </a>
                    </article>

                    {/* Pulse */}
                    <article
                        className="plan plan--pulse reveal"
                        data-testid="v2-plan-pulse"
                    >
                        <span className="plan__eyebrow">
                            <span
                                className="plan__eyebrow-dot"
                                aria-hidden="true"
                            />
                            C-ORE Pulse
                        </span>
                        <h3 className="plan__name">Pulse</h3>
                        <p className="plan__tag">
                            Monthly rhythm &mdash; the management layer, always
                            on.
                        </p>

                        <div className="plan__price">
                            <span className="plan__price-currency">
                                &#8377;
                            </span>
                            <span className="plan__price-amount">6,999</span>
                            <span className="plan__price-unit">/ month</span>
                        </div>
                        <p className="plan__price-hint">
                            Billed monthly &middot; Cancel anytime
                        </p>

                        <span className="plan__divider" aria-hidden="true" />

                        <ul className="plan__features">
                            <li className="plan__feature plan__feature--carried">
                                <ArrowCarry /> Everything in Trial
                            </li>
                            <li className="plan__feature">
                                <Check /> C-ORE One CRM Suite included
                            </li>
                            <li className="plan__feature">
                                <Check /> Financial Sync
                            </li>
                            <li className="plan__feature">
                                <Check /> Command Center
                            </li>
                            <li className="plan__feature">
                                <Check /> Smart Alerts
                            </li>
                            <li className="plan__feature">
                                <Check /> Forecasting &amp; Company Trajectory
                            </li>
                            <li className="plan__feature">
                                <Check /> C-ORE CMO execution
                            </li>
                            <li className="plan__feature">
                                <Check /> WhatsApp alerts
                            </li>
                            <li className="plan__feature">
                                <Check /> Cancel anytime
                            </li>
                        </ul>

                        <a
                            className="plan__cta plan__cta--outline"
                            href={SIGNUP_PULSE_URL}
                            data-testid="v2-plan-pulse-cta"
                        >
                            Start Pulse
                        </a>
                    </article>

                    {/* Command — Most Popular */}
                    <article
                        className="plan plan--command plan--popular reveal"
                        data-testid="v2-plan-command"
                    >
                        <span className="plan__badge">Most Popular</span>
                        <span className="plan__eyebrow">
                            <span
                                className="plan__eyebrow-dot"
                                aria-hidden="true"
                            />
                            C-ORE Command
                        </span>
                        <h3 className="plan__name">Command</h3>
                        <p className="plan__tag">
                            Annual plan &mdash; full C-Suite management, priority
                            support.
                        </p>

                        <div className="plan__price">
                            <span className="plan__price-currency">
                                &#8377;
                            </span>
                            <span className="plan__price-amount">49,900</span>
                            <span className="plan__price-unit">/ year</span>
                        </div>
                        <p className="plan__price-hint">
                            2 months effectively free vs monthly
                        </p>

                        <span className="plan__divider" aria-hidden="true" />

                        <ul className="plan__features">
                            <li className="plan__feature plan__feature--carried">
                                <ArrowCarry /> Everything in Pulse
                            </li>
                            <li className="plan__feature">
                                <Check /> C-ORE One CRM Suite included
                            </li>
                            <li className="plan__feature">
                                <Check /> Full C-Suite management
                            </li>
                            <li className="plan__feature">
                                <Check /> Advanced business intelligence
                            </li>
                            <li className="plan__feature">
                                <Check /> Command Center &amp; execution controls
                            </li>
                            <li className="plan__feature">
                                <Check /> Priority support
                            </li>
                            <li className="plan__feature">
                                <Check /> 2 months effectively free
                            </li>
                        </ul>

                        <a
                            className="plan__cta plan__cta--primary"
                            href={SIGNUP_COMMAND_URL}
                            data-testid="v2-plan-command-cta"
                        >
                            Upgrade to Command
                        </a>
                    </article>

                    {/* Sovereign — Best Value */}
                    <article
                        className="plan plan--sovereign reveal"
                        data-testid="v2-plan-sovereign"
                    >
                        <span className="plan__badge plan__badge--gradient">
                            Best Value
                        </span>
                        <span className="plan__eyebrow">
                            <span
                                className="plan__eyebrow-dot"
                                aria-hidden="true"
                            />
                            C-ORE Sovereign
                        </span>
                        <h3 className="plan__name">Sovereign</h3>
                        <p
                            className="plan__headline"
                            data-testid="v2-plan-sovereign-headline"
                        >
                            Complete C-ORE Ecosystem
                        </p>
                        <p className="plan__tag">
                            12-month access. Fund + Expert unlocked.
                        </p>

                        <div className="plan__price">
                            <span className="plan__price-currency">
                                &#8377;
                            </span>
                            <span className="plan__price-amount">1,99,900</span>
                            <span className="plan__price-unit">/ year</span>
                        </div>
                        <p className="plan__price-hint">
                            12-month access &middot; Complete C-ORE ecosystem
                        </p>

                        <span className="plan__divider" aria-hidden="true" />

                        <ul className="plan__features">
                            <li className="plan__feature plan__feature--carried">
                                <ArrowCarry /> Everything in Command
                            </li>
                            <li className="plan__feature">
                                <Check /> C-ORE One CRM Suite included
                            </li>
                            <li className="plan__feature plan__feature--exclusive plan__feature--stacked">
                                <Check />
                                <span className="plan__feature-text">
                                    <strong className="plan__feature-title">
                                        C-ORE Fund
                                    </strong>
                                    <span className="plan__feature-desc">
                                        Funding readiness &amp; funding
                                        opportunities
                                    </span>
                                </span>
                            </li>
                            <li className="plan__feature plan__feature--exclusive plan__feature--stacked">
                                <Check />
                                <span className="plan__feature-text">
                                    <strong className="plan__feature-title">
                                        C-ORE Expert
                                    </strong>
                                    <span className="plan__feature-desc">
                                        Access to experienced professionals
                                        across domains
                                    </span>
                                </span>
                            </li>
                            <li className="plan__feature">
                                <Check /> Priority support
                            </li>
                            <li className="plan__feature">
                                <Check /> Complete C-ORE ecosystem
                            </li>
                        </ul>

                        <a
                            className="plan__cta plan__cta--gradient"
                            href={SIGNUP_SOVEREIGN_URL}
                            data-testid="v2-plan-sovereign-cta"
                        >
                            Unlock Sovereign
                        </a>
                    </article>
                </div>

                <div
                    className="pricing__trust reveal"
                    data-testid="v2-pricing-trust"
                >
                    <div className="pricing__trust-item">
                        <span
                            className="pricing__trust-icon"
                            aria-hidden="true"
                        >
                            <ShieldIcon />
                        </span>
                        Secure payments &middot; Razorpay
                    </div>
                    <div className="pricing__trust-item">
                        <span
                            className="pricing__trust-icon"
                            aria-hidden="true"
                        >
                            <ReceiptIcon />
                        </span>
                        GST invoice included
                    </div>
                    <div className="pricing__trust-item">
                        <span
                            className="pricing__trust-icon"
                            aria-hidden="true"
                        >
                            <BoltIcon />
                        </span>
                        Instant activation
                    </div>
                    <div className="pricing__trust-item">
                        <span
                            className="pricing__trust-icon"
                            aria-hidden="true"
                        >
                            <XIcon />
                        </span>
                        Cancel anytime
                    </div>
                </div>
            </div>
        </section>
    );
}
